import { Component } from '@angular/core';
import { ColmecTirePolicyListConfigService } from '../../../services/colmec-tire-policy-list-config.service';
import { gungCheckAndDownloadFile } from 'gung-standard';
import { HttpClient } from '@angular/common/http';
import { ColmecModalService } from '../../../services/colmec-modal.service';

@Component({
    selector: 'colmec-tire-policy-list',
    templateUrl: './colmec-tire-policy-list.component.html',
    styleUrls: ['./colmec-tire-policy-list.component.scss'],
    standalone: false
})
export class ColmecTirePolicyListComponent {
  constructor(
    public configService: ColmecTirePolicyListConfigService,
    protected http: HttpClient,
    protected colmecModalService: ColmecModalService
  ) { }

  public openTirePolicyImportModal(): void {
    this.colmecModalService.openTirePolicyImportModal().then(
      _ => { },
      _ => { }
    );
  }

  public downloadTirePolicy(): void {
    gungCheckAndDownloadFile(this.http, 'json/colmec-tire-policy/excel/export', 'tire-policies');
  }
}
